import { network } from './network';

export async function report(opts) {
	const res = await network({
		url: 'https://report.virelia.vip/api/data_report',
		method: 'post',
		headers: {
			'App-Id': opts.appid
		},
		params: {
			...opts,
			invite_code: '',
			extra_data: JSON.stringify({
				url: window.location.href
			})
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}